import { TTrackEventData, TTrackPageViewData } from '@src/tracking/constant';

export const DELIVERY_DATA_TRACKING_EVENTS = {
  deliveryData_select: {
    component_name: 'delivery data',
    component_type: 'sheet',
    component_action: 'delivery data select',
  },
  deliveryData_view: {
    component_name: 'delivery data',
    component_type: 'sheet',
    component_action: 'tracked orders view',
    orders_tracked: '',
  },
};

export type TDeliveryDataSelect = TTrackEventData<{ component_action?: string }>;

export type TDeliveryDataView = TTrackEventData<{
  orders_tracked?: string;
  component_action?: string;
}>;
